import { createThemeCompiler } from '../../../utils';

export const dropdownThemeCompiler = createThemeCompiler(({ borderRadius, palette, stroke }) => ({
    dropdown: {
        colors: {
            dividerColor: palette.neutralTertiary,
            default: {
                fieldBackgroundColor: palette.white,
                fieldBorderColor: '#C8CED7',
                fieldTextColor: palette.neutralPrimary,
                iconColor: palette.neutralPrimary,
                optionBackgroundColor: '',
                optionGroupTextColor: palette.neutralPrimary,
                optionTextColor: palette.neutralPrimary
            },
            disabled: {
                fieldBackgroundColor: palette.neutralQuaternary,
                fieldBorderColor: palette.neutralTertiary,
                fieldTextColor: palette.neutralPrimaryAlt,
                iconColor: palette.neutralPrimaryAlt,
                optionBackgroundColor: '',
                optionGroupTextColor: '',
                optionTextColor: ''
            },
            error: {
                fieldBackgroundColor: palette.redPale,
                fieldBorderColor: palette.red,
                fieldTextColor: palette.neutralPrimary,
                iconColor: palette.neutralPrimary,
                optionBackgroundColor: '',
                optionGroupTextColor: '',
                optionTextColor: ''
            },
            focused: {
                fieldBackgroundColor: palette.white,
                fieldBorderColor: palette.themePrimary,
                fieldTextColor: palette.neutralPrimary,
                iconColor: palette.neutralPrimary,
                optionBackgroundColor: '#e9f1fd',
                optionGroupTextColor: '',
                optionTextColor: palette.themePrimary
            },
            hovered: {
                fieldBackgroundColor: palette.white,
                fieldBorderColor: palette.themePrimary,
                fieldTextColor: palette.neutralPrimary,
                iconColor: palette.neutralPrimary,
                optionBackgroundColor: '#F1F2F4',
                optionGroupTextColor: '',
                optionTextColor: palette.neutralPrimary
            },
            selected: {
                fieldBackgroundColor: palette.white,
                fieldBorderColor: palette.themePrimary,
                fieldTextColor: palette.neutralPrimary,
                iconColor: '',
                optionBackgroundColor: palette.themePrimary,
                optionGroupTextColor: '',
                optionTextColor: palette.white
            },
            selectAndFocused: {
                fieldBackgroundColor: palette.white,
                fieldBorderColor: palette.themePrimary,
                fieldTextColor: palette.neutralPrimary,
                iconColor: '',
                optionBackgroundColor: palette.themePrimary,
                optionGroupTextColor: '',
                optionTextColor: palette.white
            }
        },
        composites: {
            calloutBorderWidth: stroke.none,
            fieldBorderRadius: borderRadius.curvedSmall,
            fieldBorderWidth: stroke.thin
        }
    }
}));
